import styled, { css } from 'styled-components';
import { main_server_image_ip } from '../../communication_system/communication_ips';
import { formatKoreanDateTime } from '../../utils/format/formatDate';

//management-dashboard common attribute
export const MANAGEMENT_ICON = {
    photo: '📸',
    reply: '🚨',
    approve: '🚪',
    account: '💳',
    order: '🛒',
};

//management-overview attribute
export const MANAGEMENT_OVERVIEW = [
    {
        id: 'photoAuth',
        icon: MANAGEMENT_ICON.photo,
        title: '카메라 인증 대기',
        value: 'photo_auth_cnt',
    },
    {
        id: 'report-member',
        icon: MANAGEMENT_ICON.reply,
        title: '신고',
        value: 'report_cnt',
        alertKey: 'is_fishing_alert',
        alertLabel: '위험',
    },
    {
        id: 'approve-gathering',
        icon: MANAGEMENT_ICON.approve,
        title: '모임 개설 대기',
        value: 'gathering_approval_cnt',
    },
    {
        id: 'gathering-account',
        icon: MANAGEMENT_ICON.account,
        title: '계좌 승인 대기',
        value: 'gathering_account_cnt',
    },
    {
        id: 'order',
        icon: MANAGEMENT_ICON.account,
        title: '공동구매 주문',
        value: 'product_cnt',
        alertKey: 'is_product_alert',
        alertLabel: '우선 처리',
    },
];

//management-detail attribute
export const MANAGEMENT_DETAIL_TABLE_CONFIG_VARIANT = ['photoAuth', 'report-member', 'report-content', 'approve-gathering', 'gathering-account', 'approve-join', 'order'];

/* 각 테이블마다 컬럼의 종류가 다르기에 해당 객체에서 각 컬럼의 스타일링, 이미지 렌더, 모달 렌더를 관리합니다. */

const renderModal = (v, handleModal, modalType, modalProps, sinorYn = false, variant) => {
    const sinorYnValue = variant === 'photoAuth' ? false : sinorYn !== '시럽';
    return <ModalCell onClick={() => handleModal(modalType, modalProps, sinorYnValue, variant)}>{v}</ModalCell>;
};

/**columns 의 key 는 리스폰스로 오는 객체의 구조를 분해하기 위해 사용됩니다. */
/**해당 객체의 dept1의 이름은 위의  MANAGEMENT_DETAIL_TABLE_CONFIG_VARIANT 의 요소와 이름이 동일해야 합니다 수정시 주의해 주세요*/
export const MANAGEMENT_DETAIL_TABLE_CONFIG = {
    photoAuth: {
        icon: MANAGEMENT_ICON.photo,
        title: '카메라 인증 대기중',
        unit: '건',
        columns: [
            { key: 'status', label: '카메라 인증 상태', textColorRender: (v) => <TextColorCell $color={'#3FB05B'}>{v}</TextColorCell> },
            { key: 'request_time', label: '요청 시간', formatter: formatKoreanDateTime },
            {
                key: 'nick_name',
                label: '닉네임',
                modalType: 'userDetail',
                modalProps: 'user_id',
                queryVariant: 'photoAuth',
                modalRender: renderModal,
            },
            { key: 'gender', label: '성별', textColorRender: (v) => <TextColorCell $color={v === '남자' ? '#0080FB' : '#FF0D7D'}>{v}</TextColorCell> },
            { key: 'age', label: '나이' },
            { key: 'profile', label: '프로필 사진', imageRender: (v) => <ImageCell src={v === null ? '/images/noneImage.png' : main_server_image_ip + v} alt="이미지" /> },
            { key: 'auth_photo', label: '카메라 인증', imageRender: (v) => <ImageCell src={v === null ? '/images/noneImage.png' : main_server_image_ip + v} alt="이미지" /> },
        ],
    },
    'report-member': {
        icon: MANAGEMENT_ICON.reply,
        title: '신고 회원',
        report_description: '어제부터 오늘까지 신고된 회원 목록입니다',
        unit: '명',
        columns: [
            { key: 'account_status', label: '회원 이용 상태', alertCode: 'account_status_code', textColorRender: (v, code) => <TextColorCell $color={code !== 0 && '#FF0000'}>{v}</TextColorCell> },
            { key: 'reported_at', label: '요청 시간', formatter: formatKoreanDateTime },
            {
                key: 'nick_name',
                label: '피 신고자 닉네임',
                modalType: 'userDetail',
                queryVariant: 'report-member',
                modalProps: 'user_id',
                modalRender: renderModal,
            },

            { key: 'report_reason', label: '신고 사유', alertCode: 'is_fishing_alert', textColorRender: (v, code) => <TextColorCell $color={code === 1 && '#FF0000'}>{v}</TextColorCell> },
            { key: 'report_cnt', label: '누적 신고횟수', alertCode: 'report_cnt', textColorRender: (v, code) => <TextColorCell $color={code >= 3 && '#FF0000'}>{v}</TextColorCell> },
            { key: 'report_app', label: '신고 앱' },
            { key: 'profile', label: '프로필 사진', imageRender: (v) => <ImageCell src={v === null ? '/images/noneImage.png' : main_server_image_ip + v} alt="이미지" /> },
        ],
    },
    'report-content': {
        icon: MANAGEMENT_ICON.reply,
        title: '신고 게시글',
        unit: '건',
        columns: [
            {
                key: 'exposure_yn',
                label: '노출 상태',
                textColorRender: (v) => (v === 1 ? <TextColorCell $color="#3FB05B">{'ON'}</TextColorCell> : <TextColorCell $color="#FF0000">{'OFF'}</TextColorCell>),
            },
            { key: 'reported_at', label: '요청 시간', formatter: formatKoreanDateTime },
            {
                key: 'nick_name',
                label: '피 신고자 닉네임',
                modalType: 'userDetail',
                modalProps: 'user_id',
                queryVariant: 'report-content',
                modalRender: renderModal,
            },
            {
                key: 'report_reason',
                label: '신고 사유',
                alertCode: 'is_fishing_alert',
                textColorRender: (v, code) => <TextColorCell $color={code === 1 && '#FF0000'}>{v}</TextColorCell>,
            },
            {
                key: 'content',
                label: '게시글 내용',
                modalType: 'reportContent',
                queryVariant: 'report-content',
                modalProps: 'content_id',
                modalRender: renderModal,
            },
            {
                key: 'report_cnt',
                label: '누적 신고횟수',
                textColorRender: (v) => <TextColorCell $color={v >= 3 && '#FF0000'}>{v}</TextColorCell>,
            },
            {
                key: 'account_status',
                label: '이용상태',
                alertCode: 'account_status_code',
                textColorRender: (v, code) => <TextColorCell $color={code === 2 && '#FF0000'}>{v}</TextColorCell>,
            },
        ],
    },
    'approve-gathering': {
        icon: MANAGEMENT_ICON.approve,
        title: '모임 개설 대기중',
        unit: '건',
        columns: [
            { key: 'approve_status', label: '승인 상태', textColorRender: (v) => <TextColorCell $color={'#3FB05B'}>{v}</TextColorCell> },
            { key: 'request_at', label: '요청 시간', formatter: formatKoreanDateTime },
            {
                key: 'gathering_name',
                label: '모임 명',
                routeParamsKey: 'gathering_id',
                routerRender: (v, paramsId) => (
                    <RouterCell href={`/gathering/detail/${paramsId}`} style={{ fontWeight: '500', fontSize: '15px', lineHeight: '143%', letterSpacing: '1.45%', textAlign: 'center' }}>
                        {v}
                    </RouterCell>
                ),
            },
            { key: 'gathering_image', label: '모임 사진', imageRender: (v) => <ImageCell src={v === null ? '/images/noneImage.png' : main_server_image_ip + v} alt="이미지" /> },
            { key: 'gathering_explanation', label: '모임 소개' },
            { key: 'interest', label: '모임 주제' },
            { key: 'area', label: '활동 지역' },
            { key: 'owner_nick_name', label: '모임장 닉네임' },
            { key: 'owner_photo', label: '모임장 사진', imageRender: (v) => <ImageCell src={v === null ? '/images/noneImage.png' : main_server_image_ip + v} alt="이미지" /> },
        ],
    },

    'gathering-account': {
        icon: MANAGEMENT_ICON.account,
        title: '계좌 인증 대기',
        unit: '건',
        columns: [
            { key: 'account_status', label: '상태', textColorRender: (v) => <TextColorCell $color={'#3FB05B'}>{v}</TextColorCell> },
            { key: 'request_at', label: '요청 시간', formatter: formatKoreanDateTime },
            { key: 'gathering_name', label: '모임 명' },
            {
                key: 'owner_nick_name',
                label: '모임장 닉네임',
                modalType: 'userDetail',
                queryVariant: 'gathering-account',
                modalProps: 'user_id',
                modalRender: renderModal,
            },
            { key: 'account_holder', label: '예금주' },
            { key: 'bank_name', label: '은행' },
            { key: 'account_number', label: '계좌번호' },
        ],
    },
    'approve-join': {
        icon: MANAGEMENT_ICON.approve,
        title: '3일 이상 미승인 모임원',
        unit: '명',
        columns: [
            {
                key: 'gathering_name',
                label: '모임 명',
                routeParamsKey: 'gathering_id',
                routerRender: (v, paramsId) => (
                    <RouterCell href={`/gathering/detail/${paramsId}`} style={{ fontWeight: '500', fontSize: '15px', lineHeight: '143%', letterSpacing: '1.45%', textAlign: 'center' }}>
                        {v}
                    </RouterCell>
                ),
            },
            { key: 'pending_cnt', label: '대기중인 모임원' },
            { key: 'owner_nick_name', label: '모임장 닉네임' },
            { key: 'owner_phone_no', label: '모임장 전화번호' },
        ],
    },
    order: {
        icon: MANAGEMENT_ICON.order,
        title: '공동구매 주문',
        unit: '건',
        columns: [
            {
                key: 'order_status',
                label: '배송 상태',
                alertCode: 'order_status_code', //배송 상태 코드 { 0 : 상품 준비중, 1:배송중, 2 : 배송 완료}
                textColorRender: (v, code) => {
                    const textColor = code === 1 ? '#3FB05B' : code === 0 ? '#0088FF' : '#000000';
                    return <TextColorCell $color={textColor}>{v}</TextColorCell>;
                },
            },
            { key: 'request_at', label: '요청 시간', formatter: formatKoreanDateTime },
            {
                key: 'pay_status',
                label: '결제 상태',
                alertCode: 'pay_status_code',
                textColorRender: (v, code) => {
                    const textColor = code === 2 ? '#0088FF' : code === 3 ? '#FF0000' : '#000000';
                    return <TextColorCell $color={textColor}>{v}</TextColorCell>;
                },
            },
            {
                key: 'product_name',
                label: '주문 상품',
                routeParamsKey: 'pay_id',
                routerRender: (v, paramsId) => <RouterCell href={`/order/${paramsId}`}>{v}</RouterCell>,
            },
            { key: 'order_cnt', label: '수량' },
            { key: 'name', label: '회원 명' },
            { key: 'receiver', label: '수취인 명' },
            { key: 'address', label: '수취 주소' },
        ],
    },
};

const ImageCell = styled.img`
    width: 75px;
    height: 75px;
    object-fit: cover;
    border-radius: 16px;
`;
const TextColorCell = styled.span`
    color: #000000;
    ${(props) =>
        props.$color &&
        css`
            color: ${({ $color }) => `${$color}`};
        `}
`;
const ModalCell = styled.div`
    cursor: pointer;
    text-decoration: underline;
`;
const RouterCell = styled.a`
    cursor: pointer;
    text-decoration: underline;
    color: #000000;
`;
